import Styles from './TodoCheckbox.module.scss'
import cx from 'classnames'
import { ReactComponent as TodoCheckboxIcon } from './todoCheckboxIcon.svg'
import { CSSTransition } from 'react-transition-group'
import { useRef, useState } from 'react'

interface Props {
  checked: boolean
  disabled?: boolean
  onClick?: (e: React.MouseEvent) => void
  className?: string
  label?: string
  readOnly?: boolean
  animate?: boolean
}

export const TodoCheckbox = ({ className, checked, disabled, onClick, label, readOnly = false }: Props) => {
  const nodeRef = useRef<HTMLDivElement>(null)
  const [inProp, setInProp] = useState(false)

  const handleClick = (e: React.MouseEvent) => {
    setInProp(!inProp)
    onClick?.(e)
    e.stopPropagation()
  }

  return (
    <button
      className={cx(Styles.button, Styles.task, className, {
        [Styles.checked]: checked,
        [Styles.readOnly]: readOnly,
      })}
      disabled={disabled}
      onClick={handleClick}
      aria-label={checked ? 'Undo todo' : 'Mark as complete'}
    >
      <CSSTransition
        nodeRef={nodeRef}
        in={inProp}
        timeout={150}
        classNames={{
          enter: Styles.enter,
          enterActive: Styles.enterActive,
          exit: Styles.exit,
          exitActive: Styles.exitActive,
        }}
      >
        <div ref={nodeRef} className={Styles.checkboxContainer}>
          <TodoCheckboxIcon
            className={cx(Styles.taskIcon, {
              [Styles.completedTaskIcon]: checked || inProp,
            })}
          />
        </div>
      </CSSTransition>

      {label && <span className={Styles.label}>{label}</span>}
    </button>
  )
}
